import { Box } from '@mui/material';
import { Audits, entityAuditQuery, getResponseErrorMessage, IWork } from '@diana/core';
import { useMemo, useState } from 'react';
import { THING_PAGE_NS } from '../../../../i18n';
import { useTranslation } from 'react-i18next';
import { ThingActivity } from './ThingActivity';
import { useQuery } from '@tanstack/react-query';

export const ThingActivities = ({ thing }: { thing: IWork }) => {
  const [keyword, setKeyword] = useState('');
  const { t } = useTranslation(THING_PAGE_NS);

  const query = entityAuditQuery.getByEntityId({ entityId: thing?.id ?? '' });
  const {
    isFetching: isLoading,
    data: entityAudits,
    error,
  } = useQuery({
    queryKey: query.key,
    queryFn: query.fn,
    enabled: Boolean(thing?.id),
  });

  const errorMessage = useMemo(() => getResponseErrorMessage(error), [error]);

  const filteredThingAudits = useMemo(() => {
    if (!entityAudits) return [];
    return entityAudits.filter(
      (audit) =>
        !keyword || JSON.stringify(audit).toLocaleLowerCase().includes(keyword.toLocaleLowerCase()),
    );
  }, [keyword, entityAudits]);

  const Content = useMemo(() => {
    return filteredThingAudits.map((audit, index) => (
      <Box key={index} pt={1}>
        <ThingActivity keyword={keyword} key={index} thing={thing} audit={audit} />
      </Box>
    ));
  }, [filteredThingAudits, thing, keyword]);

  return (
    <Audits
      searchProps={{
        keyword,
        setKeyword,
      }}
      labels={{
        search: t('activity.labels.search'),
        noResult: t('activity.labels.noResult'),
      }}
      auditsExist={Boolean(filteredThingAudits.length)}
      isLoading={isLoading}
      errorMessage={errorMessage}
    >
      {Content}
    </Audits>
  );
};
